// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"449":"071ce1d0","1623":"aeb41c94","5576":"9687ae4b","7379":"10b7bff0","8366":"071ce1d0","8578":"d2d207fa","9114":"071ce1d0"}[chunkId] + ".chunk.css";
};